import React, { useContext } from 'react';
export const defaultValue = {
    mode: 'nest',
    showArrow: false,
    activeKey: undefined,
    animation: 'opacity',
    visible: false,
    rightVisible: false,
    onChangeVisible: (_value) => undefined,
    onChangeRightVisible: (_value) => undefined,
};
export const DropdownContext = React.createContext(defaultValue);
export const useDropdown = () => useContext(DropdownContext);
